import 'babel-polyfill';
import { $, Masonry, imagesLoaded } from './lib';

import layout from './components/layout';
import cards from './components/cards';
import carousel from './components/carousel';
import cardCarousel from './components/card-carousel';
import savedProducts from './components/savedProducts';
import tiles from './components/tiles';
import sidenav from './components/sidenav';
import lightbox from './components/lightbox';
import sticky from './components/sticky';
import select from './components/select';
import truncate from './components/truncate';
import maps from './components/maps';
import productTypes from './components/productTypes';
import form from './components/form';
import autocomplete from './components/autocomplete';
import login from './components/login';
import estates from './components/estates';
import { activateProducts } from './components/product';
import { initialize as fbInit } from './components/facebook';
import estatePicker from './components/estatePicker';
import videos from './components/videos';
import { registerTrackingHandlers } from './components/tracking';
import tabs from './components/tabs';
import rangeSlider from './components/products/inputs/rangeSlider';
// Imports for new lot map feature
// import { initMap, setPins, showMarkerPopout, filterZoom } from './components/maps/map-lotmap';


// import stock from './components/stock';
import code from './components/code';

import './icons';

// experimenting for GTM/GA stuff
import { gtmEventPDFDownload } from './components/products/index';

$(() => {
  estatePicker();
});

$(window).on('load', () => {
  layout();
  select();
  productTypes();
  maps();
  carousel();
  cardCarousel();
  savedProducts();
  tiles();
  sidenav();
  window.lightbox = lightbox();
  window.sticky = sticky();
  cards(Masonry, imagesLoaded);
  truncate();
  form();
  login();
  activateProducts();
  autocomplete();
  estates();
  fbInit();
  videos();
  registerTrackingHandlers();
  code();
  tabs('.tab-module');
  rangeSlider(null, '.range-slider');
  window.gtmEventPDFDownload = gtmEventPDFDownload; // this lets me make it available to the product details page onclick.
});
